var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center"},[_c('v-btn',{attrs:{"color":"red","outlined":""},on:{"click":_vm.onDelete}},[_vm._v("Xóa khách hàng")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }